<template>
  <div>
    <div class="container"
         v-show="!data"
         v-if="allList">
      <i-videolist :video_newest="allList"></i-videolist>
    </div>
    <div class="none"
         v-show="data">
      <img src="../../assets/images/nonelist.png"
           alt="">
      <p>暂无更多</p>
    </div>
  </div>
</template>
<script>
import iVideolist from '../container/videoList'
import iSearch from '../container/search'
import bus from '../bus/index'
import AppSetting from '../../AppSetting'
export default {
  data () {
    return {
      title: "",
      params: null,
      allList: null,
      data: false,
    }
  },
  props: {
    inputvalue: String,
  },

  created () {
  },
  watch: {
    'inputvalue': function (value) {
      if (!value) {
        this.getList()
      }



    }
  },
  methods: {


    getList () {
      let more = JSON.parse(sessionStorage.getItem('ra_more'));
      console.log(params)
      let params = {
        title: this.inputvalue,
        type: '',
        // order: 'new',
      };

      // sessionStorage.setItem('ra_search',JSON.stringify(params));
      this.$postHttp(AppSetting.baseUrl + '/video/list/condition', params).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          let data = res.data.list;

          if (data.length < 1) {
            this.data = true;
          } else {
            this.allList = data;
            this.data = false;
          }
          this.$waiting.hide();
        }

      })
    },
  },
  computed: {},
  components: {
    iVideolist,
    iSearch
  },
  mounted () {
    this.params = JSON.parse(sessionStorage.getItem('ra_more'));
    bus.$on('sendValue', (val) => {
      this.getList();
      this.$postHttp('/common/entgroup/info', {}).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          let data = res.data.list;
          data.map((item) => {
            if (item.egId == val.type) {
            }
          })
        }

      })
    })

    this.getList();
  },

}
</script>
<style scoped lang="scss">
.search {
  height: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #ffffff;
  > img {
    width: 2.79rem;
    height: 0.38rem;
  }
  > div {
    display: flex;
    width: 3.8rem;
    height: 0.7rem;
    border: 1px solid #dbdbdb;
    padding-left: 0.2rem;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    margin-left: 0.32rem;

    input {
      width: 3rem;

      border: none;
      outline: none;
    }
    input::placeholder {
      color: #999999;
    }
    > div {
      width: 0.6rem;
      height: 0.68rem;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffb441;
      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
}
.none {
  width: 100%;
  min-height: 260px;
  box-sizing: border-box;
  text-align: center;
  img {
    width: 100px;
    display: inline-block;
    margin: 80px auto 0px;
    /*width: 100%;*/
  }
  p {
    font-size: 16px;
    color: #999999;
    text-align: center;
  }
}
.container {
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  /*margin-bottom: 1.18rem;*/
}
</style>



// WEBPACK FOOTER //
// src/components/video/alllist.vue